// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './common/vant'
// 导入二维码组件
import VueQriously from 'vue-qriously/dist/vue-qriously'

// 导入svg-icon
// import './icons'

// 引入二维码
Vue.use(VueQriously)

// Vue.config.productionTip = false

// 动态标题
router.beforeEach((to, from, next) => {
  // Get the page title from the route meta data that we have defined
  // See further down below for how we setup this data
  const title = to.meta.title

  //Take the title from the parameters
  const titleFromParams = to.query.pageTitle;
  // If the route has a title, set it as the page title of the document/page
  if (title) {
    document.title = title
  }
  // If we have a title from the params, extend the title with the title
  // from our params
  if (titleFromParams) {
    document.title = `${titleFromParams}`;
  }
  // Continue resolving the route
  next()
})


/* eslint-disable no-new */
// 实例化Vue实例
new Vue({
  // 定义Vue绑定的跟元素
  el: '#app',
  // 将上面声明的路由器传递到根Vue实例
  router,
  // 声明App组件，这样上面的<App/>元素就可以生效
  components: { App },
  // 用<App/>代替根元素
  template: '<App/>'
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js